class RegistrationFormBehavior extends Sparkle.PageBuilder.Components.Behavior {
  constructor() {
    super(...arguments);

    if (this.isSandbox()) {
      this.el.show();
    } else {
      // Re-render the component to get the latest dynamic content like how many slots are left
      this.el.hide();
      this.render().always(() => {
        this.el.show();
        if (this.el.has("mobile-cta-target")) {
          return Sparkle.MobileCTA.renderSpComponentModalTeaser(
            this.el,
            "[mobile-cta-target]",
            "[data-sparkle-container]",
          );
        }
      });
    }
  }
}
RegistrationFormBehavior.register("registration_form");
